if (!customElements.get('crew-reel-carousel')) {
  class CrewReelCarousel extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.crew-reel__card')];
      this.total = this.cards.length;
      if (this.total < 2) return;

      this.range = Number(this.dataset.range ?? 0);
      this.active = Number(this.dataset.start ?? 0);
      this.track = this.querySelector('.crew-reel__track');
      this.status = this.querySelector('.crew-reel__status');
      this.swipe = null;
      this.skipClick = false;

      for (const button of this.querySelectorAll('[data-step]')) {
        button.addEventListener('click', () => this.go(this.active + Number(button.dataset.step)));
      }
      this.track.addEventListener('keydown', this.onKeydown);
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerCancel);
      this.track.addEventListener('click', this.onCardClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    slotFor(index) {
      let offset = (index - this.active + this.total) % this.total;
      if (offset * 2 > this.total) offset -= this.total;
      return offset;
    }

    go(index, announce = true) {
      const next = ((index % this.total) + this.total) % this.total;
      if (next === this.active) return;
      this.active = next;

      this.cards.forEach((card, index) => {
        const offset = this.slotFor(index);
        const slot = Math.max(-2, Math.min(2, offset));
        const previous = Number(card.dataset.pos);
        const isOut = Math.abs(offset) > this.range;

        if (Math.abs(slot - previous) > 1) card.classList.add('is-jump');
        card.dataset.pos = slot;
        card.classList.toggle('is-out', isOut);
        if (offset === 0) {
          card.removeAttribute('aria-hidden');
        } else {
          card.setAttribute('aria-hidden', 'true');
        }
      });

      for (const card of this.querySelectorAll('.is-jump')) {
        void card.offsetWidth;
        card.classList.remove('is-jump');
      }

      if (announce && this.status) {
        this.status.textContent = this.cards[this.active].getAttribute('aria-label');
      }
    }

    onKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.go(this.active - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.go(this.active + 1);
      }
    };

    onPointerDown = (event) => {
      this.skipClick = false;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.swipe = { x: event.clientX, y: event.clientY };
    };

    onPointerUp = (event) => {
      if (!this.swipe) return;
      const dx = event.clientX - this.swipe.x;
      const dy = event.clientY - this.swipe.y;
      this.swipe = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      this.skipClick = true;
      this.go(this.active + (dx < 0 ? 1 : -1));
    };

    onPointerCancel = () => {
      this.swipe = null;
    };

    onCardClick = (event) => {
      if (this.skipClick) {
        this.skipClick = false;
        return;
      }
      const card = event.target.closest('.crew-reel__card');
      if (!card || card.dataset.pos === '0' || card.classList.contains('is-out')) return;
      this.go(this.cards.indexOf(card));
    };

    onBlockSelect = (event) => {
      const index = this.cards.findIndex((card) => card === event.target || card.contains(event.target));
      if (index > -1) this.go(index, false);
    };
  }

  customElements.define('crew-reel-carousel', CrewReelCarousel);
}
